export const Grain = () => {
  return <div className="grain" aria-hidden="true" data-testid="grain-overlay" />;
};

export default Grain;
